module.exports = __webpack_public_path__ + "giving/public/shared/assets/amex.svg?136f5938957e77cc6a3f0086d02a85d0";